export const faqs = [
  {
    question: '¿Necesito WhatsApp Business para usar el bot?',
    answer: 'Sí. Para activar el bot del Plan Profesional debes conectar mediante Meta un número compatible con WhatsApp Business. La agenda web, el perfil público y el Plan Gratis funcionan sin conectar WhatsApp.',
  },
  {
    question: '¿Cuánto cuesta el Plan Profesional?',
    answer: 'El cobro comienza al activar la suscripción y es de $29.900 COP mensuales con un profesional incluido. Si tienes más de un profesional, se suman $19.900 COP al mes por cada profesional adicional.',
  },
  {
    question: '¿En qué plan está disponible el bot de WhatsApp?',
    answer: 'El bot de WhatsApp está incluido en el Plan Profesional de $29.900 COP al mes. Activarlo es opcional y no tiene un precio separado. El Plan Gratis funciona sin el bot.',
  },
  {
    question: '¿Tengo que cambiar mi número de WhatsApp?',
    answer: 'La posibilidad de conservarlo depende de que tu número y tu configuración sean compatibles con el proceso de conexión de Meta. OficioYa verifica esa conexión durante la activación; no necesitas conectar ningún número para usar el Plan Gratis.',
  },
  {
    question: '¿OficioYa sirve para negocios con muchos servicios diferentes?',
    answer: 'Sí. El Plan Gratis permite 1 categoría y hasta 3 servicios. El Plan Profesional amplía el límite a 10 categorías y servicios ilimitados, con duraciones, precios y profesionales configurables.',
  },
  {
    question: '¿Mis clientes tienen que instalar una app?',
    answer: 'No. Tus clientes pueden reservar desde el perfil público sin instalar una aplicación. En el Plan Profesional también puedes activar el bot para atender reservas por WhatsApp.',
  },
  {
    question: '¿Sirve si soy profesional independiente?',
    answer: 'Sí. OficioYa está pensado para negocios pequeños, barberías y profesionales independientes que quieren verse más organizados sin contratar una recepcionista.',
  },
  {
    question: '¿Qué pasa si tengo varios profesionales?',
    answer: 'El Plan Profesional incluye 1 profesional. Puedes añadir más profesionales por $19.900 COP al mes cada uno; cada profesional puede manejar disponibilidad, servicios y horarios propios.',
  },
  {
    question: 'Ya tengo agenda o cuaderno. ¿Por qué necesitaría OficioYa?',
    answer: 'Porque OficioYa reúne agenda, clientes, horarios y reservas online en un solo panel. Si activas el bot del Plan Profesional, también puedes automatizar parte del agendamiento por WhatsApp cuando estás atendiendo o fuera de horario.',
  },
  {
    question: '¿Qué pasa si un cliente quiere cambiar o cancelar una cita?',
    answer: 'Con el bot del Plan Profesional activo, el cliente puede gestionar cambios o cancelaciones por WhatsApp. Sin el bot, puedes hacer esos cambios directamente desde la agenda web.',
  },
  {
    question: '¿El asistente responde fuera del horario del negocio?',
    answer: 'Sí. Esa es una de las ventajas principales: tus clientes pueden escribir cuando quieran y el asistente puede ayudarles a consultar disponibilidad o iniciar el proceso de agendamiento, incluso cuando tú no estás pendiente del celular.',
  },
  {
    question: '¿Necesito saber de tecnología para usarlo?',
    answer: 'No. La agenda, los clientes y las reservas se administran desde un panel web. Si eliges Profesional, puedes activar opcionalmente el bot de WhatsApp para complementar ese flujo.',
  },
  {
    question: '¿Y si una conversación necesita atención personal?',
    answer: 'Puedes tomar el control de la conversación desde WhatsApp Business. El bot se detiene mientras respondes y puedes reanudarlo cuando quieras.',
  },
  {
    question: '¿Esto reemplaza la atención humana?',
    answer: 'No. La mejora. El asistente cubre lo repetitivo de la agenda para que tú y tu equipo puedan concentrarse en atender mejor cuando la conversación necesita criterio humano.',
  },
  {
    question: '¿Hay alguna permanencia mínima?',
    answer: 'No. La suscripción es mensual y puedes cancelar la próxima renovación cuando quieras. Conservarás el acceso hasta finalizar el período que ya pagaste.',
  },
];
